import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { ArrowUpRight } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import IndustriesData from '../../data/industriesData';
import ServicesData from '../../data/servicesData';

const MainFooter = () => {
   const year = new Date().getFullYear();

   return (
      <>
         <footer>
            <div className="footer__area">
               <div className="footer__newsletter">
                  <div className="tw-container tw-mx-auto">
                     <div className='tw-flex tw-flex-wrap tw-justify-between'>
                        <p>Subscribe to Harsoft Insights, our occasional look at software, product, and growth.</p>
                        <form className="footer__subscribe-form" onSubmit={(e) => e.preventDefault()}>
                           <label htmlFor="footer-subscribe-email" className="tw-sr-only">Your email address</label>
                           <input id="footer-subscribe-email" type="email" placeholder="Your email address" required />
                           <button type="submit" aria-label="Subscribe">
                              <ArrowUpRight size={18} />
                           </button>
                        </form>
                     </div>
                  </div>
               </div>
               <div className="tw-container tw-mx-auto">
                  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-justify-between tw--mx-3 footer__columns">
                     <div className="tw-w-full tw-px-3">
                        <div className="footer__widget mb-45 tw-mr-12">
                           <div className="footer__brand-logo mb-25">
                              <Link to="/">
                                 <img src="assets/img/logo/Harsoft_Logo_White_png.png" alt="Harsoft Solutions" />
                              </Link>
                           </div>
                           <p className="footer__address mb-20">
                              Akshaya Heights, 2nd Floor, Plot Nos. 133(P), 134, 135 &amp; 136(P), Road No. 9,
                              Sai Aishwarya Layout Rd, Chitrapuri Colony, Khajaguda, Hyderabad, Telangana 500104.
                           </p>
                           <p className="footer__contact mb-30">
                              <a href="mailto:info@harsofts.com">info@harsofts.com</a>
                              <a href="tel:+919030350309">+91-90303 50309</a>
                           </p>
                           <NavLink to="/contact" className="btn-more" aria-label="Explore UI/UX & Product Design">
                              <span className="btn-text">Contact Us</span>
                              <span className="btn-icon" aria-hidden="true">
                                 <ArrowUpRight size="16px" className="icon" />
                              </span>
                           </NavLink>
                        </div>
                     </div>
                     <div className="tw-px-3 md:tw-col-span-2 tw-flex tw-flex-col sm:tw-flex-row tw-gap-6 sm:tw-gap-0 tw-justify-between">
                        <div className="tw-flex tw-px-3">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Industries</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <ul className="footer__link-list">
                                    {IndustriesData.map((industry) => (
                                       <li key={industry.id}>
                                          <NavLink to={`/industries/${industry.slug}`}>{industry.name}</NavLink>
                                       </li>
                                    ))}
                                 </ul>
                              </div>
                           </div>
                        </div>

                        <div className="tw-flex tw-px-3">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Services</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <ul className="footer__link-list">
                                    {ServicesData.map((service) => (
                                       <li key={service.id}>
                                          <NavLink to={service.link}>{service.title}</NavLink>
                                       </li>
                                    ))}
                                 </ul>
                              </div>
                           </div>
                        </div>

                        <div className="tw-flex tw-px-3">
                           <div className="footer__widget mb-45">
                              <div className="footer__widget-title">
                                 <h4>Quick Links</h4>
                              </div>
                              <div className="footer__widget-content">
                                 <ul className="footer__link-list">
                                    <li><NavLink to="/ourStory">Our Story</NavLink></li>
                                    <li><NavLink to="/software-product-development">Offerings</NavLink></li>
                                    <li><NavLink to="/blogs">Insights</NavLink></li>
                                    <li><NavLink to="/contact">Contact</NavLink></li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </div>


                  </div>
               </div>

               <div className="footer__copyright">
                  <div className="tw-container tw-mx-auto">
                     <div className="footer__copyright-inner">
                        <p className="footer__copyright-text">© Copyright @{year} Harsoft Solutions · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/terms-and-conditions">Terms &amp; Conditions</Link></p>
                        <div className="footer__social">
                           <ul className='tw-m-0 tw-p-0'>
                              <li>
                                 <a href='https://www.linkedin.com/in/harsoft-solutions-760808312/' aria-label="LinkedIn"><FaLinkedinIn /></a>
                              </li>
                              <li>
                                 <a href='https://www.facebook.com/profile.php?id=61593556735259' aria-label="Facebook"><FaFacebookF /></a>
                              </li>
                              <li>
                                 <a href='https://x.com/Harsofts' aria-label="Twitter"><FaTwitter /></a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </footer>
      </>
   );
};

export default MainFooter;
